import React, { ReactElement } from 'react';
import { useSelector } from '@ecommerce/nest-ssr/common';

import type { CompanyInterface } from 'interfaces/company.interface';
import CompanyViewBadges from 'components/company-view/company-view-badges/company-view-badges';
import CompanyViewCategories from 'components/company-view/company-view-categories/company-view-categories';

import './company-view-header.scss';

const CompanyViewHeader: React.FC = (): ReactElement => {
    const company = useSelector((state: {company: CompanyInterface;}) => state.company);

    return (
        <div className="container">
            <div className="company-view-header">
                <div>
                    <h1 className="company-view-header__title">
                        {company.slogan || company.name}
                        <span className="company-view-header__title-span">
                            &nbsp;- opinie
                        </span>
                    </h1>
                    <CompanyViewCategories company={company} />
                </div>
                <CompanyViewBadges company={company} />
            </div>
        </div>
    );
};

export default CompanyViewHeader;
